import styled from '@emotion/styled';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import React, { useCallback, useRef } from 'react';

const StyledSwipeableDrawer = styled(SwipeableDrawer)`
  & .MuiPaper-root {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }
`;

export function SwipeableBottomDrawer({
  handleClose,
  isOpen,
  children,
  className,
  onOpen
}) {
  const ref = useRef(null);

  const measuredRef = useCallback((node) => {
    if (node) {
      ref.current = node;
      onOpen?.(ref);
    }
  });

  return (
    <StyledSwipeableDrawer
      ref={measuredRef}
      className={className}
      anchor="bottom"
      // The SwipeableDrawer's documentation recommends enabling/disabling certain props if the user is on iOS:
      // "iOS is hosted on high-end devices. The backdrop transition can be enabled without dropping frames. The performance will be good enough."

      // "iOS has a 'swipe to go back' feature that interferes with the discovery feature, so discovery has to be disabled."
      // https://material-ui.com/components/drawers/#swipeable
      // For MVP, disable both props
      disableBackdropTransition={true}
      disableDiscovery={true}
      open={isOpen}
      // onOpen & onClose are required props
      // pass a noop to avoid PropTypes warning
      onOpen={() => {}}
      onClose={handleClose}
      onBackdropClick={handleClose}
      data-testid="BottomSheet"
    >
      {children}
    </StyledSwipeableDrawer>
  );
}
